import * as angular from "angular";
import {TextTemplatePurposeType} from "../text-templates/types/text-template-purpose.type";
import TextTemplatesService from "../text-templates/services/text-templates-service.service";
import {TextTemplateReceiverType} from "../text-templates/types/text-template-receiver.type";
import {HolderType} from "../commons/types/holder.type";
import {$accountsFactory} from "../account/$accounts.factory";
import {SubTasksRequestsService} from "../sub-tasks/services/sub-tasks-requests.service";
import {SitesRequestsService} from "../sites/services/sites-requests.service";
import {PreferencesRequestsService} from "./services/preferences-requests.service";
import {SettingsService} from "./services/settings-service.service";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ViewSettingsModel} from "../commons/models/view-settings.model";
import {PricePlanBundleService} from "../price-plan/services/price-plan-bundle.service";
import {PdfFormTemplatesRequestsService} from "../document-management/services/pdf-form-templates-requests.service";
import {PdfFormTemplateModel} from "../document-management/models/pdf-form-template.model";
import {SettingsRequestsService} from "./services/settings-requests.service";
import {
  AgentConfigurationProfilesService
} from "../configuration-profiles/services/agent-configuration-profiles-service.service";
import {$agentsFactory} from "../agents/$agents.factory";
import {ActionReasonEntityEnum} from "../action-reasons/enums/action-reason-entity.enum";
import {ActionReasonsServiceService} from "../action-reasons/services/action-reasons-service.service";
import {ActionReasonModel} from "../action-reasons/models/action-reason.model";
import {AgentType} from "../agents/types/agent.type";
import {AccountsService} from "../account/services/accounts-service.service";

angular
  .module('bringoz.admin.site-preferences')
  .config(sitePreferencesConfig);

/* @ngInject */
function sitePreferencesConfig($stateProvider) {

  $stateProvider
    .state('site-administration', {
      parent: 'bringoz.site',
      url: '/administration',
      abstract: true,
      template: '<site-preferences site="vm.site"></site-preferences>',
      controllerAs: 'vm',
      controller: function (siteData) {
        this.site = siteData;
      },
      resolve: {
        siteData: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSite(site.id);
        }
      }
    })

    // ************
    // Preferences
    // ************
    .state('site-administration.preferences', {
      url: '/preferences',
      abstract: true,
      template: '<ui-view/>'
    })

    // Site
    .state('site-administration.preferences.site', {
      url: '/site',
      template: '<preferences-tab preferences="vm.preferences" parent-group="vm.parentGroup"></preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationCommons, preferences) {
        this.parentGroup = 'SitePrefs';
        this.preferences = configurationCommons.getPreferencesByGroup(preferences).sitePrefs;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Site Settings'});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['SitePrefs']);
        }
      }
    })

    // Dispatching
    .state('site-administration.preferences.dispatching', {
      url: '/dispatching',
      template: '<dispatching-configuration-view preferences="vm.preferences" parent-group="vm.parentGroup"></dispatching-configuration-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationCommons, preferences) {
        this.parentGroup = 'Dispatching';
        this.preferences = configurationCommons.getPreferencesByGroup(preferences).dispatching;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Dispatching Preferences'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['Dispatching']);
        }
      }
    })

    // Price-Plans
    .state('site-administration.preferences.price-plans', {
      url: '/price-plans',
      template: '<programs-preferences-tab preferences="vm.preferences" programs="vm.programs" services-program-types-map="vm.servicesProgramTypes" line-split-configuration="vm.lineSplitConfiguration"></programs-preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, configurationCommons, programs, servicesProgramTypes, lineSplitConfiguration) {

        this.preferences = configurationCommons.getPreferencesByGroup(preferences).pricePlanPrefs;
        this.programs = programs || [];
        this.servicesProgramTypes = servicesProgramTypes;
        this.lineSplitConfiguration = !!lineSplitConfiguration ? lineSplitConfiguration[0] : {};

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Programs Preferences'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['PricePlanPrefs']);
        },
        programs: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSitePrograms();
        },
        servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSiteServicesProgramType();
        },
        lineSplitConfiguration: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getLineSplitConfiguration();
        }
      }
    })

    // Price-Plans
    .state('site-administration.preferences.email-report-configuration', {
      url: '/email-report-configuration',
      template: '<email-report-configuration-tab email-report-configurations="vm.emailReportConfigurationTemplates"></email-report-configuration-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, emailReportConfigurationTemplates) {

        this.emailReportConfigurationTemplates = emailReportConfigurationTemplates;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Email Reports Configuration'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        emailReportConfigurationTemplates: function (site, settingsRequestsService: SettingsRequestsService) {
          return settingsRequestsService.getEmailReportConfiguration();
        }
      }
    })

    .state('site-administration.preferences.web-tracker', {
      url: '/web-tracker',
      template: '<preferences-tab preferences="vm.preferences" parent-group="vm.parentGroup"></preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, configurationCommons) {
        this.parentGroup = 'WebTracking';
        this.preferences = configurationCommons.getPreferencesByGroup(preferences).webTracking;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Web Tracker'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['WebTracking']);
        }
      }
    })

    // Pricing
    .state('site-administration.preferences.pricing', {
      url: '/pricing',
      template: '<preferences-tab preferences="vm.preferences" parent-group="vm.parentGroup"></preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, configurationCommons) {
        this.parentGroup = 'Pricing';
        this.preferences = configurationCommons.getPreferencesByGroup(preferences).pricing;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Pricing Preferences'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['Pricing']);
        }
      }
    })

    .state('site-administration.preferences.dashboards', {
      url: '/dashboards',
      template: '<dashboard-configuration preferences="vm.preferences"></dashboard-configuration>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, configurationCommons) {

        this.preferences = configurationCommons.getPreferencesByGroup(preferences).dashboardPrefs;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Dashboards'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['DashboardPrefs']);
        }
      }
    })


    // Agents
    .state('site-administration.preferences.agents', {
      url: '/agents',
      template: '<agents-preferences-tab documents="vm.documents" reminders="vm.reminders" absence-reasons="vm.absenceReasons" break-types="vm.breakTypes"></agents-preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, documents, reminders, absenceReasons, breakTypes) {
        this.documents = documents;
        this.reminders = reminders
        this.absenceReasons = absenceReasons;
        this.breakTypes = breakTypes;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agents Preferences'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        documents: function (site, settingsService: SettingsService) {
          return settingsService.getAllDocuments(HolderType.AGENT);
        },
        reminders: function (site, settingsService: SettingsService) {
          return settingsService.getAllReminders(HolderType.AGENT);
        },
        absenceReasons: function (site, settingsService: SettingsService) {
          return settingsService.getAbsenceReasons();
        },
        breakTypes: function (site, splitService) {
          return splitService.getBreakTypes() || [];
        }
      }
    })

    // Vehicles
    .state('site-administration.preferences.vehicles', {
      url: '/vehicles',
      template: '<vehicles-preferences-tab documents="vm.documents" reminders="vm.reminders" status-change-reasons="vm.statusChangeReasons"></vehicles-preferences-tab>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, documents, reminders, statusChangeReasons) {
        this.documents = documents;
        this.reminders = reminders
        this.statusChangeReasons = statusChangeReasons;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Vehicles Preferences'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        documents: function (site, settingsService: SettingsService) {
          return settingsService.getAllDocuments(HolderType.VEHICLE);
        },
        reminders: function (site, settingsService: SettingsService) {
          return settingsService.getAllReminders(HolderType.VEHICLE);
        },
        statusChangeReasons: function (site, settingsService: SettingsService) {
          return settingsService.getAllVehicleStatusChangeReason();
        }
      }
    })


    // ********************
    // Cancellation Reasons
    // ********************

    // Cancellation Reasons
    .state('site-administration.action-reasons', {
      url: '/action-reasons',
      template: '<action-reasons-view action-reasons="vm.actionReasons" actions="vm.actions" selected-entity="vm.selectedEntity"></action-reasons-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, actionReasons: ActionReasonModel[], actions) {

        this.actionReasons = actionReasons;
        this.actions = actions;
        this.selectedEntity = ActionReasonEntityEnum.Delivery;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Action Reasons'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        actionReasons: function (site, actionReasonsService: ActionReasonsServiceService) {
          return actionReasonsService.getActionReasons();
        },
        actions: function (site, subTasksRequestsService) {
          return subTasksRequestsService.getTemplateActions();
        }
      }
    })

    // **********
    // Sub Tasks
    // **********

    // Sub Tasks
    .state('site-administration.sub-tasks', {
      url: '/sub-tasks',
      template: '<sub-tasks-templates-view templates="vm.templates" selected-type="vm.selectedType" actions="vm.actions"></sub-tasks-templates-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, templates, actions) {

        this.templates = templates;
        this.selectedType = 'Operational';
        this.actions = actions;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sub Tasks'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        templates: function (site, subTasksRequestsService: SubTasksRequestsService) {
          return subTasksRequestsService.getTemplates(['Operational']);
        },
        actions: function (site, subTasksRequestsService: SubTasksRequestsService) {
          return subTasksRequestsService.getTemplateActions();
        }
      }
    })


    .state('site-administration.field-configurations', {
      url: '/field-configurations',
      abstract: true,
      template: '<fields-configurations-view></fields-configurations-view>'
    })

    .state('site-administration.field-configurations.packages', {
      url: '/packages',
      template: '<package-configurations-view site-package-items="vm.sitePackageItems" flex></package-configurations-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, sitePackageItems) {
        this.sitePackageItems = sitePackageItems

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Packages'});
        triBreadcrumbsService.addCrumb({name: 'Fields'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        sitePackageItems: function (site, pricePlanBundleService: PricePlanBundleService) {
          return pricePlanBundleService.getPackageItems();
        }
      }
    })

    .state('site-administration.field-configurations.custom-fields', {
      url: '/custom-fields',
      template: '<package-custom-fields-view fields="vm.packageFields"></package-custom-fields-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, packageFields) {
        this.packageFields = packageFields

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Custom'});
        triBreadcrumbsService.addCrumb({name: 'Fields'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        packageFields: function (site, settingsService: SettingsService) {
          return settingsService.getPackageFields();
        }
      }
    })

    .state('custom-fields', {
      url: '/custom-fields',
      parent: 'bringoz.site',
      template: '<package-custom-fields-view fields="vm.packageFields"></package-custom-fields-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, packageFields) {
        this.packageFields = packageFields

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Custom'});
        triBreadcrumbsService.addCrumb({name: 'Fields'});

      },
      resolve: {
        packageFields: function (site, settingsService: SettingsService) {
          return settingsService.getPackageFields();
        }
      }
    })


    .state('site-administration.documents-management', {
      url: '/documents-management',
      template: '<documents-management-view pdf-form-templates="vm.pdfFormTemplates"></documents-management-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, pdfFormTemplates: PdfFormTemplateModel[]) {

        this.pdfFormTemplates = pdfFormTemplates;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Documents'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        pdfFormTemplates: function (pdfFormTemplatesRequestsService: PdfFormTemplatesRequestsService, site) {
          return pdfFormTemplatesRequestsService.getList();
        }
      }
    })

    .state('site-administration.travel-time', {
      url: '/travel-time',
      template: '<travel-time-view></travel-time-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Speed Adjustment'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        // pdfFormTemplates: function (pdfFormTemplatesRequestsService: PdfFormTemplatesRequestsService, site) {
        //   return pdfFormTemplatesRequestsService.getList();
        // }
      }
    })

    .state('site-administration.views-configuration', {
      url: '/views-configuration',
      template: '<views-configuration-view configuration-settings="vm.configurationSettings"></views-configuration-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationSettings: ViewSettingsModel[]) {

        this.configurationSettings = configurationSettings;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Fields'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        configurationSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getBySite(undefined);
        }
      }
    })

    .state('site-administration.shipper-portal-configuration', {
      url: '/shipper-portal-configuration',
      template: '<shipper-portal-configuration-view configuration="vm.configuration"></shipper-portal-configuration-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, shipperAppConfig) {

        this.configuration = shipperAppConfig;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Shipper Portal'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        shipperAppConfig: function (settingsRequestsService: SettingsRequestsService, $state, site) {
          return settingsRequestsService.getShipperAppConfig();
        }
      }
    })

    // **********
    // Meta Data
    // **********

    // Meta Data
    .state('site-administration.meta-data', {
      url: '/meta-data',
      template: '<preferences-meta-data-view metadata="vm.metadata"></preferences-meta-data-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, metadataSettings) {

        this.metadata = metadataSettings;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Meta Data'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    // ***************
    // General Tasks
    // ***************

    // General Tasks - Start & End
    .state('site-administration.general-tasks', {
      url: '/general-tasks',
      template: '<general-tasks-configuration-view type="vm.type" general-tasks="vm.generalTasks" preferences="vm.preferences"></general-tasks-configuration-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, generalTasks, preferences) {
        // INCLUDE_ROUTE_START_END_IN_DISPATCH_MERCH
        this.type = 'DRIVER';
        this.generalTasks = generalTasks;
        this.preferences = preferences;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'General Tasks'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        generalTasks: function (site, preferencesRequestsService: PreferencesRequestsService, tasksConstants) {
          return preferencesRequestsService.getGeneralTasks(tasksConstants.generalTasksByAgentType['DRIVER']);
          // return subTasksRequestsService.getTemplates();
        },
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['StartEndTaskPrefs']);
        }
      }
    })

    // **********
    // Modules
    // **********

    // Modules
    .state('site-administration.plan', {
      url: '/plan',
      template: '<site-plan-view plan="vm.plan"></site-plan-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, plan) {

        this.plan = plan;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Modules'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        plan: function (site, sitesRequestsService: SitesRequestsService) {
          return sitesRequestsService.getSitePlan(site.id);
        }
      }
    })

    // Modules
    .state('site-administration.expenses', {
      url: '/expenses',
      template: '<expenses-configuration preferences="vm.preferences"></expenses-configuration>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, preferences, configurationCommons) {

        this.preferences = configurationCommons.getPreferencesByGroup(preferences).expenses;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Expenses'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        preferences: function (sitesRequestsService: SitesRequestsService, site) {
          return sitesRequestsService.getSitePreferences(site.id, ['Expenses']);
        }
      }
    })

    // Providers
    .state('site-administration.providers', {
      url: '/providers',
      template: '<app-site-providers-view></app-site-providers-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Providers'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      }
    })

    .state('site-administration.groups', {
      url: '/groups',
      template: '<roles-groups extended-policy="vm.extendedPolicy" site-id="vm.siteId"></roles-groups>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, extendedPolicy, site) {

        this.extendedPolicy = extendedPolicy;
        this.siteId = site.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Groups'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        extendedPolicy: (sitesRequestsService: SitesRequestsService, site) => {
          return sitesRequestsService.getSitePolicy(site.id);
        }
      }
    })

    // **************
    // Profiles
    // **************

    // All Profiles View
    .state('site-administration.configuration-profiles', {
      url: '/configuration-profiles?:selectedTab',
      template: '<configuration-profiles-view default-profile="vm.defaultProfile" ' +
        'default-agent-profile="vm.defaultAgentProfile" default-autonomous-agent-profile="vm.defaultAutonomousAgentProfile" selected-tab="vm.selectedTab"></configuration-profiles-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, defaultProfile, defaultAgentProfile, defaultAutonomousAgentProfile) {

        this.defaultAgentProfile = defaultAgentProfile;
        this.defaultProfile = defaultProfile;
        this.defaultAutonomousAgentProfile = defaultAutonomousAgentProfile;
        this.selectedTab = $stateParams.selectedTab ? parseInt($stateParams.selectedTab) : undefined;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Configuration Profiles'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        defaultProfile: function (site, configurationProfilesService) {
          return configurationProfilesService.getDefaultProfile();
        },
        defaultAgentProfile: function (site, agentConfigurationProfilesService: AgentConfigurationProfilesService) {
          return agentConfigurationProfilesService.getDefaultAgentProfile([AgentType.Driver, AgentType.ServiceAgent, AgentType.Manager]);
        },
        defaultAutonomousAgentProfile: function (site, agentConfigurationProfilesService: AgentConfigurationProfilesService) {
          return agentConfigurationProfilesService.getDefaultAgentProfile([AgentType.Robot]);
        }
      }
    })

    // Single Profile View
    .state('site-administration.configuration-profile', {
      url: '/configuration-profile/:id',
      template: '<configuration-profile-view configuration-profile="vm.configurationProfile" ' +
        'accounts="vm.accounts" default-profile-id="vm.defaultProfileId" ' +
        'selected-tab="vm.selectedTab"></configuration-profile-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationProfile, accounts, defaultProfile) {

        this.configurationProfile = configurationProfile;
        this.accounts = accounts;
        this.defaultProfileId = defaultProfile.id;
        this.selectedTab = 'autoAssign';

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Configuration Profile'});
        triBreadcrumbsService.addCrumb({
          name: 'Configuration Profiles',
          state: 'site-administration.configuration-profiles',
          params: {selectedTab: 0}
        });
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      },
      resolve: {
        configurationProfile: function (site, $configurationProfiles, $stateParams) {
          return $configurationProfiles($stateParams.id).$asyncValue();
        },
        accounts: function (site, $accounts: $accountsFactory, accountsService: AccountsService, $stateParams) {
          return accountsService.getAll({configProfileId: $stateParams.id, isDemand: true, limit: 500});
        },
        defaultProfile: function (site, configurationProfilesService) {
          return configurationProfilesService.getDefaultProfile();
        }
      }
    })

    // agent configuration profile
    .state('site-administration.agent-configuration-profile', {
      url: '/agent-configuration-profile/:id',
      template: '<agent-configuration-profile-view configuration-profile="vm.configurationProfile" ' +
        'agent-ids="vm.agentIds" default-profile-id="vm.defaultProfileId" ' +
        'selected-tab="vm.selectedTab"></agent-configuration-profile-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationProfile, agentIds, defaultProfile) {
        this.configurationProfile = configurationProfile;
        this.agentIds = agentIds;
        this.defaultProfileId = defaultProfile.id;
        this.selectedTab = 'appPreferences';

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: configurationProfile?.name || 'Profile'});
        triBreadcrumbsService.addCrumb({
          name: 'Agent Configuration Profiles',
          state: 'site-administration.configuration-profiles',
          params: {selectedTab: 1}
        });
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        configurationProfile: function (site, $agentConfigurationProfiles, $stateParams) {
          return $agentConfigurationProfiles($stateParams.id).$asyncValue();
        },
        agentIds: function (site, $agents: $agentsFactory, $stateParams) {
          const agentsRef = $agents();
          return agentsRef.$getAll({configurationId: $stateParams.id, limit: 500});
        },
        defaultProfile: function (site, agentConfigurationProfilesService: AgentConfigurationProfilesService) {
          return agentConfigurationProfilesService.getDefaultAgentProfile([AgentType.Driver, AgentType.ServiceAgent, AgentType.Manager]);
        }
      }
    })

    // agent configuration profile
    .state('site-administration.autonomous-agent-configuration-profile', {
      url: '/autonomous-agent-configuration-profile/:id',
      template: '<autonomous-agent-configuration-profile-view configuration-profile="vm.configurationProfile" ' +
        'agent-ids="vm.agentIds" default-profile-id="vm.defaultProfileId" ' +
        'selected-tab="vm.selectedTab"></autonomous-agent-configuration-profile-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, configurationProfile, agentIds, defaultProfile) {
        this.configurationProfile = configurationProfile;
        this.agentIds = agentIds;
        this.defaultProfileId = defaultProfile.id;
        this.selectedTab = 'appPreferences';

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({
          name: configurationProfile?.name || configurationProfile?.id,
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({
          name: 'Autonomous Agent Configuration Profiles',
          state: 'site-administration.configuration-profiles',
          params: {selectedTab: 2}
        });
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      },
      resolve: {
        configurationProfile: function (site, $agentConfigurationProfiles, $stateParams) {
          return $agentConfigurationProfiles($stateParams.id).$asyncValue();
        },
        agentIds: function (site, $agents: $agentsFactory, $stateParams) {
          const agentsRef = $agents();
          return agentsRef.$getAll({configurationId: $stateParams.id, limit: 500});
        },
        defaultProfile: function (site, agentConfigurationProfilesService: AgentConfigurationProfilesService) {
          return agentConfigurationProfilesService.getDefaultAgentProfile([AgentType.Robot]);
        }
      }
    })


    // *********************
    // Notifications
    // *********************

    .state('site-administration.notifications', {
      url: '/notifications',
      abstract: true,
      template: '<ui-view class="full-height"></ui-view>'
    })

    // *********************
    // Notifications - SMS
    // *********************
    .state('site-administration.notifications.sms', {
      url: '/sms',
      abstract: true,
      template: '<notifications-configuration></notifications-configuration>'
    })
    .state('site-administration.notifications.sms.recipient', {
      url: '/recipient',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.RECIPIENT
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recipient'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.agent', {
      url: '/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications,) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.sender', {
      url: '/sender',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.SENDER;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sender'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.issuer', {
      url: '/issuer',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.ISSUER;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Issuer'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.admin', {
      url: '/admin',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.ADMIN;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Admin'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.branch', {
      url: '/branch',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.BRANCH_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.BRANCH_CONTACTS, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.team', {
      url: '/team',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.TEAM_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.TEAM_CONTACTS, TextTemplatePurposeType.Sms);
        }
      }
    })
    .state('site-administration.notifications.sms.operation-contacts', {
      url: '/operation-contacts',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.OPERATIONAL_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.OPERATIONAL_CONTACTS, TextTemplatePurposeType.Sms);
        }
      }
    })

    // **********************
    // Notifications - Email
    // **********************

    .state('site-administration.notifications.email', {
      url: '/email',
      abstract: true,
      template: '<notifications-configuration></notifications-configuration>'
    })
    .state('site-administration.notifications.email.recipient', {
      url: '/recipient',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.RECIPIENT;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recipient'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.Email);

        }
      }
    })
    .state('site-administration.notifications.email.agent', {
      url: '/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications,) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.sender', {
      url: '/sender',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.SENDER;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sender'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.issuer', {
      url: '/issuer',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ISSUER;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Issuer'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.admin', {
      url: '/admin',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ADMIN;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Admin'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.branch', {
      url: '/branch',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.BRANCH_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.BRANCH_CONTACTS, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.team', {
      url: '/team',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.TEAM_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.TEAM_CONTACTS, TextTemplatePurposeType.Email);
        }
      }
    })
    .state('site-administration.notifications.email.operation-contacts', {
      url: '/operation-contacts',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.OPERATIONAL_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.OPERATIONAL_CONTACTS, TextTemplatePurposeType.Email);
        }
      }
    })


    // **********************
    // Notifications - Whatsapp
    // **********************

    .state('site-administration.notifications.whatsapp', {
      url: '/whatsapp',
      abstract: true,
      template: '<notifications-configuration></notifications-configuration>',
    })
    .state('site-administration.notifications.whatsapp.recipient', {
      url: '/recipient',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.RECIPIENT;
        this.purpose = TextTemplatePurposeType.WhatsApp;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recipient'});
        triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.WhatsApp);
        }
      }
    })
    .state('site-administration.notifications.whatsapp.agent', {
      url: '/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications,) {

        this.notifications = notifications; // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.WhatsApp;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.WhatsApp);
        }
      }
    })
    .state('site-administration.notifications.whatsapp.sender', {
      url: '/sender',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications // Filter only SMS/undefined
        this.type = TextTemplateReceiverType.SENDER;
        this.purpose = TextTemplatePurposeType.WhatsApp;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sender'});
        triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.WhatsApp);
        }
      }
    })
    .state('site-administration.notifications.whatsapp.issuer', {
      url: '/issuer',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ISSUER;
        this.purpose = TextTemplatePurposeType.WhatsApp;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Issuer'});
        triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.WhatsApp);
        }
      }
    })
    .state('site-administration.notifications.whatsapp.admin', {
      url: '/admin',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ADMIN;
        this.purpose = TextTemplatePurposeType.WhatsApp;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Admin'});
        triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.WhatsApp);
        }
      }
    })

    // SMS Audit
    .state('site-administration.sms-audit', {
      url: '/sms-audit',
      template: '<sms-messages-view do-display-queries="true"></sms-messages-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'SMS Audit'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});

      }
    })

    .state('site-administration.content-templates', {
      url: '/content-templates',
      template: '<content-templates-view></content-templates-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Content Templates'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});

      }
    })

    .state('site-administration.audit-log', {
      url: '/audit-log',
      template: '<app-settings-audit-log-view></app-settings-audit-log-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Audit Log'});
        triBreadcrumbsService.addCrumb({name: 'Settings'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});
      }
    })
}
